import React from "react"
import { Navigate, Outlet, Route, Routes, useParams } from "react-router"
import Tabs, { Tab } from "../../components/Tabs"
import Accounts from "./Accounts"
import BankAccounts from "./BankAccounts"
import Communications from "./Communications"
import Details from "./Details"
import Documents from "./Documents"
import IdVerifications from "./IdVerifications"
import PersonProfile from "./PersonProfile"
import Security from "./Security"

const PersonPage = () => {
  const { id } = useParams<{ id: string }>()

  return (
    <div data-testid="personPage">
      <PersonProfile />
      <Tabs>
        <Tab to={`/person/${id}/accounts`} label="Accounts" defaultTab />
        <Tab to={`/person/${id}/details`} label="Details" />
        <Tab to={`/person/${id}/documents`} label="Documents" />
        <Tab to={`/person/${id}/communications`} label="Communications" />
        <Tab to={`/person/${id}/security`} label="Security" />
        <Tab to={`/person/${id}/bank-accounts`} label="Bank accounts" />
        <Tab to={`/person/${id}/id-verifications`} label="Id verifications" />
      </Tabs>
      <div>
        {/* <Routes>
          <Route path="/person/:id/accounts" element={<Accounts />} />
          <Route path="/person/:id/details" element={<Details />} />
          <Route path="/person/:id/documents" element={<Documents />} />
          <Route path="/person/:id/communications" element={<Communications />} />
          <Route path="/person/:id/security" element={<Security />} />
          <Route path="/person/:id/bank-accounts" element={<BankAccounts />} />
          <Route path="/person/:id/id-verifications" element={<IdVerifications />} />
          <Route path="/person/:id" element={<Navigate to={`/person/${id}/accounts`} replace />} />
        </Routes> */}
        <Outlet />
      </div>
    </div>
  )
}

export default PersonPage
